// Feature flags — secciones desactivadas temporalmente en la app.
// Los componentes siguen en el proyecto (TikTokLivePanel.jsx, PuntosPanel.jsx)
// para retomarlos después: basta con poner el flag en true.
export const FEATURE_TIKTOK = false;
export const FEATURE_PUNTOS = false;
